<template>
    <div>
      <h1>Chat</h1>
    </div>
  </template>
  
  <script setup>
  </script>